'use strict';

var React              = require('react'),
    _                  = require('underscore'),
    ApplicationActions = require('js/shared/actions/application-actions.js'),
    classnames         = require('classnames');

var RadiobuttonInput = React.createClass({

  propTypes: {
    // type: React.PropTypes.number.isRequired,
    title: React.PropTypes.string.isRequired,
    fieldName: React.PropTypes.string.isRequired,

    // list types
    list: React.PropTypes.arrayOf(React.PropTypes.string),

    // anything that can continue via. a trigger, like hitting Enter
    nextCallback: React.PropTypes.func,

    // existing value state
    value: React.PropTypes.string,
    onReview: React.PropTypes.bool,
    hasError: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      value: null,
      onReview: false
    };
  },


  getInitialState: function() {
    return {
      value: this.props.value
    };
  },

  _handleChange: function(evt) {
    this.setState({
      value: evt.target.value
    });
    ApplicationActions.updateField(this.props.fieldName, evt.target.value);
  },

  _renderElement: function(option) {
    var labelClasses = classnames({
      'QuestionInput-radioLabel': true,
      'QuestionInput-radioLabel--review': this.props.onReview
    });

    var radioClasses = classnames({
      'QuestionInput-radioButton': true,
      'QuestionInput-radioButton--review': this.props.onReview
    });

    var containerClasses = classnames({
      'QuestionInput-radioContainer': true,
      'QuestionInput-radioContainer--review': this.props.onReview
    });
    return (
      <label
        key={option}
        className={containerClasses}>
        <input
          className={radioClasses}
          type="radio"
          name={this.props.fieldName}
          value={option}
          checked={option === this.state.value}
          onChange={this._handleChange} />
        <span className={labelClasses}>{option}</span>
      </label>
    );
  },

  _renderElements: function(elements) {
    return _.map(this.props.list, option => this._renderElement(option));
  },

  render: function () {
    var subtitle = null;
    if(!this.props.onReview) {
      subtitle = <div className="QuestionInput-subtitle">
        {this.props.subtitle}
      </div>;
    }

    var titleClasses = classnames({
      'QuestionInput-title': true,
      'QuestionInput-title--compact': this.props.onReview,
      'QuestionInput-title--review': this.props.onReview
    });

    var containerClasses = classnames({
      'QuestionInput': true,
      'QuestionInput--review': this.props.onReview
    });

    return (
      <div className={containerClasses}>
        <div className={titleClasses}>
          {this.props.title}
        </div>
        {subtitle}
        {this._renderElements(this.props.list)}
      </div>
    );
  }
});

module.exports = RadiobuttonInput;



/** WEBPACK FOOTER **
 ** ./js/screens/form/input/radiobutton.jsx
 **/